import { defineComponent as _defineComponent } from 'vue'
import { MapStylePresetType } from '@/components/DesignStudio/MapStyleProperties/types';
import CLazy from '@/components/CLazy.vue';
import { TippyComponent } from 'vue-tippy';

interface Props {
    preset: MapStylePresetType;
    disabled?: boolean;
}

interface Emits {
    (event: 'select', preset: MapStylePresetType): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStylePropertiesCreateThumbnail',
  props: {
    preset: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'select', preset: MapStylePresetType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { preset: MapStylePresetType, disabled: boolean };





const handleClick = () => {
    if (props.disabled) return;
    emit('select', props.preset);
};

return { __sfc: true,props, emit, handleClick, CLazy, TippyComponent }
}

})